/** Use the measured session frame period, never an assumed 60 Hz. */
export function withinFrameCount(errors: readonly number[], frameMs: number | null): number | null {
  if (frameMs === null || !Number.isFinite(frameMs) || frameMs <= 0) return null;
  return errors.filter(e => Number.isFinite(e) && Math.abs(e) <= frameMs + 1e-6).length;
}
